import PartnersAnimation from 'app/components/Common/Passthru/PartnersAnimation';
import { partnerAltName } from 'app/components/Common/Passthru/animation-data';
import TranslateString from 'app/components/Common/TranslateString';
import classNames from 'classnames';
import Image from 'next/image';
import React from 'react';
import { connect } from 'react-redux';
import styles from '../../../styles/passthru.module.scss';
import Helper from '../../modules/Helper';
import CarDetailCard from '../Passthru/CarDetailCard';
import FlightDetailCard from '../Passthru/FlightDetailCard';

let redirectByClientPT2 = Helper.bool(process.env.NEXT_PUBLIC_REDIRECT_BY_CLIENT as string);
const useDefaultPasstrhu = Helper.checkQueryStringKeyValue('f', 'm');

if (Helper.hasPT(2)) {
	if (useDefaultPasstrhu) {
		redirectByClientPT2 = false;
	} else {
		redirectByClientPT2 = true;
	}
}

type ProgressLoadingProps = {
	enabledVert: string;
	foundLink: string;
	show?: boolean;
	enableProgressLoading?: boolean;
	redirectImmediately?: boolean;
	durationDetectRedirectLink: number;
	selectedToLocation: { city: string; country: string };
	partner?: string;
};
type ProgressLoadingState = {
	pausedFrame: boolean;
	isStopped: boolean;
	isPaused: boolean;
	interval: null | number;
	domainName?: string;
	userCountry: string;
	lng: string;
	city: string;
	country: string;
	uid: string;
	imid: string;
};
class ProgressLoading extends React.Component<ProgressLoadingProps, ProgressLoadingState> {
	constructor(props: ProgressLoadingProps) {
		super(props);
		this.state = {
			isStopped: false,
			isPaused: false,
			interval: null,
			pausedFrame: true,
			domainName: '',
			userCountry: '',
			lng: '',
			city: '',
			country: '',
			uid: '',
			imid: '',
		};
	}

	onEnterFrame = () => {
		if (this.state.pausedFrame) {
			this.setState(
				{
					isPaused: true,
				},
				() => {
					setTimeout(() => {
						this.redirectLink(this.props.foundLink);
					}, 100);
				}
			);
		}
	};

	componentDidUpdate(prevProps: ProgressLoadingProps) {
		if (this.props.foundLink !== prevProps.foundLink && this.props.foundLink) {
			if (this.props.redirectImmediately || prevProps.redirectImmediately) {
				setTimeout(() => {
					this.redirectLink(this.props.foundLink);
				}, 300);
			} else {
				this.checkLink(this.props.foundLink);
			}
		}
	}

	checkLink(link: string) {
		const { partner } = this.props;
		const pausedFrame = !!partner;
		const domainName = partner;

		if (pausedFrame && redirectByClientPT2) {
			this.setState({
				pausedFrame,
				domainName,
			});
		} else if (Helper.hasPT(3) && domainName) {
			const { durationDetectRedirectLink } = this.props;
			let timeout = 2000 - durationDetectRedirectLink;
			if (timeout < 0) {
				timeout = 0;
			}
			setTimeout(() => {
				this.setState(
					{
						domainName,
					},
					() => {
						setTimeout(() => {
							this.redirectLink(link);
						}, 1000);
					}
				);
			}, timeout);
		} else {
			this.redirectLink(link);
		}
	}

	redirectLink = (link: string) => {
		window.location.href = link;
	};

	// renderPT3 = () => {
	// 	const { domainName } = this.state;
	// 	return (
	// 		<div id="passthru-p3" className={this.props.enabledVert}>
	// 			<div className="container">
	// 				<div className="row justify-content-center p-0">
	// 					<div className="col-xl-6 col-lg-8 col-12">
	// 						<h3
	// 							className="title"
	// 							dangerouslySetInnerHTML={{
	// 								__html: Helper.trans('passthru.pt3.title'),
	// 							}}
	// 						/>
	// 						<br />
	// 						<div id="loading-to-partner">
	// 							<img
	// 								alt={process.env.NEXT_PUBLIC_SITE_NAME}
	// 								src="/images/logos/logo.png?v1.0"
	// 								srcSet="/images/logos/logo@2x.png?v1.0 2x,
	//                            /images/logos/logo@3x.png?v1.0 3x"
	// 								className="logo flex-1"
	// 							/>
	// 							<div id="animation" className="flex-1">
	// 								<div className="mouse_scroll">
	// 									<div>
	// 										<span className="m_scroll_arrows unu"></span>
	// 										<span className="m_scroll_arrows doi"></span>
	// 										<span className="m_scroll_arrows trei"></span>
	// 									</div>
	// 								</div>
	// 							</div>
	// 							<div className="flex-1 brand-redirection-logo">
	// 								{domainName ? (
	// 									<img src={`/images/companies/${domainName}.png`} alt="" className="img-fluid " />
	// 								) : null}
	// 							</div>
	// 						</div>
	// 						<div
	// 							className="brand-redirection"
	// 							dangerouslySetInnerHTML={{
	// 								__html: domainName
	// 									? Helper.trans('passthru.pt3.foundBrand', { brand: Helper.capitalize(domainName) })
	// 									: '',
	// 							}}
	// 						/>
	// 						<div>{this.getDetailCardComponent()}</div>
	// 					</div>
	// 				</div>
	// 			</div>
	// 		</div>
	// 	);
	// };

	getDetailCardComponent = () => {
		switch (this.props.enabledVert) {
			case 'flights':
				return <FlightDetailCard />;
			case 'cars':
				return <CarDetailCard />;
			default:
				return <></>;
		}
	};

	render() {
		const { enabledVert } = this.props;
		const { isPaused } = this.state;
		const isCruises = enabledVert === 'cruises';

		let partner = this.props.partner;

		if (partnerAltName.hasOwnProperty(partner || '')) {
			partner = partnerAltName[partner as keyof typeof partnerAltName];
		}

		if (!this.props.enableProgressLoading && !this.props.show) {
			return <></>;
		}
		// const PT3Verts = ['flights', 'cars'];
		// const showNewPassthru =
		// 	Helper.hasPT(3) && (Helper.checkQueryStringKeyValue('vert', PT3Verts) || PT3Verts.indexOf(enabledVert) !== -1);

		let vertIcon = '/images/aero.png?v1.0';

		switch (enabledVert) {
			case 'cars':
				vertIcon = '/images/car.png?v1.0';
				break;
			case 'hotels':
				vertIcon = '/images/building.png?v1.0';
				break;
			case 'cruises':
				vertIcon = '/images/icon-ship.png?v1.0';
				break;
			default:
				break;
		}

		// if (showNewPassthru) {
		// 	return this.renderPT3();
		// }

		return (
			<div id="progress-loading" className="flights">
				<div className="body">
					<div id="logo">
						<Image
							alt={process.env.NEXT_PUBLIC_SITE_NAME as string}
							src="/images/logos/logo.png?v1.0"
							className="logo flex-1"
							width={260}
							height={40}
						/>
					</div>
					{!redirectByClientPT2 ? (
						<div id="img-area">
							<Image id="search-icon" src="/images/zoom.png" alt="Zoom" width={120} height={120} />
							<Image id="vert-icon" src={vertIcon} alt="Vertical" width={50} height={50} />
						</div>
					) : partner ? (
						<div>
							<PartnersAnimation vert={enabledVert} partner={partner as string} redirectToPartner={this.onEnterFrame} />
						</div>
					) : (
						<div className={styles.partnerPlaceholder}>
							<div className={classNames(styles.partnerLogos, styles.partnerLogosPlaceholder)}>
								<div className={classNames(styles.animationWrapper, styles.animationPlaceholder)}>
									<div className={classNames(styles.top, styles.topLeft, styles.curvedLine, styles.animatedLine)} />
									<div className={classNames(styles.top, styles.topRight, styles.curvedLine, styles.animatedLine)} />
									<div
										className={classNames(styles.bottom, styles.bottomLeft, styles.curvedLine, styles.animatedLine)}
									/>
									<div
										className={classNames(styles.bottom, styles.bottomRight, styles.curvedLine, styles.animatedLine)}
									/>
								</div>
							</div>
						</div>
					)}

					{!isPaused ? (
						<p>
							<TranslateString i18nKey="passthru.description" />
						</p>
					) : (
						''
					)}

					{redirectByClientPT2 && isPaused && partner ? (
						<p>
							<TranslateString i18nKey="passthru.cheapestPrice" variables={{ brand: Helper.capitalize(partner) }} />
						</p>
					) : null}
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state: any) => ({
	enableProgressLoading: state.base.enableProgressLoading,
	enabledVert: state.base.enabledVert,
	foundLink: state.passthru.foundLink,
	redirectImmediately: state.passthru.redirectImmediately,
	durationDetectRedirectLink: state.passthru.durationDetectRedirectLink,
	selectedToLocation: state.flight.selectedToLocation,
	lng: state.base.lng,
});
export default connect(mapStateToProps)(ProgressLoading);
